import MainComponent from "components/Main";

import Search from "components/Search";
import ContentBlock from "components/ContentBlock";
import ItemHuman from "components/ItemHuman";

import PropTypes from 'prop-types';

import './index.less';

export default class SelectVisit extends MainComponent {
    static propTypes = {
        value: PropTypes.number,
        label: PropTypes.string,
        items: PropTypes.array,
        onChange: PropTypes.func,
    };
    static defaultProps = {
        value: null,
        label: "",
        items: [],
        onChange: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            search: "",
        };
    }

    selectItem(id, info) {
        const { onChange } = this.props;

        this.state.search = "";

        if (onChange?.apply)
            onChange(id, info);
    }

    getById(id) {
        if (!id)
            return null;

        const info = globalThis.appPageView.getDoctorById(id);

        return info?.id ? info : null;
    }

    formatItem({ doctorId, beginDate, endDate }, withoutSname = false) {
        let doctor = this.getById(doctorId);
        if (withoutSname)
            doctor = { ...doctor, sname: "" };

        const firstRow = this._helper.date.toPeriodStr(beginDate, endDate);
        const secondRow = this._helper.string.formatFullName(doctor);

        return { firstRow, secondRow };
    }

    insertSelected(it) {
        const { firstRow, secondRow } = this.formatItem(it);

        return (
            <ItemHuman
                firstRow={firstRow}
                secondRow={secondRow}
                active={true}
                removeCb={this.selectItem.bind(this, null, null)}
            />
        );
    }

    getFiltered(items, search) {
        if (!search)
            return items;

        return items.filter(it => {
            const { firstRow, secondRow } = this.formatItem(it, true);

            return (firstRow.toLowerCase().includes(search) || secondRow.toLowerCase().includes(search));
        });
    }

    render() {
        const { search } = this.state;
        const { value, label, items } = this.props;

        const selected = value ? items.find(it => it.id === value) : false;

        return (
            <div className="selectVisit selectDoctor flex col gap16">
                <div className="flex col gap8">
                    {!!label && (
                        <div className="label text p2">{this.tr(label)}</div>
                    )}
                    {!selected ? (
                        <Search
                            placeHolder={"main.searchVisit"}
                            itemStyle={"search"}
                            onChange={this.changeState.bind(this, "search")}
                        />
                    ) : this.insertSelected(selected)}
                </div>
                {!selected && (
                    <ContentBlock noTitle={true} itemStyle="bodySelDoctor scrolling">
                        <div className="flex col gap4">
                            {this.getFiltered(items, search.toLowerCase()).map((it, i) => {
                                const { firstRow, secondRow } = this.formatItem(it);

                                return (
                                    <ItemHuman
                                        key={i}
                                        firstRow={firstRow}
                                        secondRow={secondRow}
                                        onClick={this.selectItem.bind(this, it.id, it)}
                                    />
                                );
                            })}
                        </div>
                    </ContentBlock>
                )}
            </div>
        );
    }
}
